<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="pb-12">
          <setup-payroll-container-view />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    components: {
      SetupPayrollContainerView: () => import('@/components/hris/setup/payroll/ContainerView'),
    },
  }
</script>
